import { render, staticRenderFns } from "./UpdateFormModal.vue?vue&type=template&id=7484b236&scoped=true&"
import script from "./UpdateFormModal.vue?vue&type=script&lang=js&"
export * from "./UpdateFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7484b236",
  null
  
)

export default component.exports